import { useEffect } from 'react';
import { Flex, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { useVinExtractionService } from '../../services/vinExtractionService';
import { parseCarDocuments } from '../../utils/vinExtraction';
import { cardTitleStyle, mutedSmallStyle } from './vinExtractionStyles';
import { isLoadFailed, useVinRequest } from './useVinRequest';
import VinLoadError from './VinLoadError';
import CarDocumentList from './CarDocumentList';

/**
 * Links to the car's current registration / CoC documents (GET /cars/:carId/documents), loaded when the drawer
 * opens or the car changes. Links only: never an <img>, never the URL text, never logged (E30, Q1). [privacy]
 */
export default function CarDocuments({ carId, open }) {
    const { t } = useTranslation('vinExtraction');
    const { getCarDocuments } = useVinExtractionService();
    const { load, run } = useVinRequest({ request: () => getCarDocuments(carId), parse: parseCarDocuments });

    useEffect(() => {
        if (open && carId) run();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, carId]);

    return (
        <Flex vertical gap={spacing[1]} aria-busy={load.status === 'loading'}>
            <h3 style={{ ...cardTitleStyle, margin: 0 }}>{t('drawer.documents.title')}</h3>
            {load.status === 'loading' && <Skeleton active title={false} paragraph={{ rows: 2 }} />}
            {isLoadFailed(load) && (
                <VinLoadError
                    status={load.status}
                    error={load.error}
                    message={t('drawer.documents.loadFailed')}
                    invalidDescription={t('drawer.documents.invalidResponse')}
                    onRetry={run}
                />
            )}
            {load.status === 'ready' && <CarDocumentList items={load.data.items} />}
            <span style={mutedSmallStyle}>{t('drawer.documents.note')}</span>
        </Flex>
    );
}
